// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
    demo: {
        title: 'France',
        introduction: 'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l\'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n\'a pas fait que survivre cinq siècles, mais s\'est aussi adapté à la bureautique informatique, sans que son contenu n\'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.',
    },
    docs: {
        hi: 'Bonjour',
        description: 'Besoin d\'aide? \n Consultez notre documentation.',
        documentation: 'documentation',
    },
    app: 'application',
    user: 'utilisateur',
    list: 'liste',
    edit: 'éditer',
    shop: 'boutique',
    blog: 'blog',
    post: 'poste',
    mail: 'e-mail',
    chat: 'discuter',
    cards: 'cartes',
    posts: 'des postes',
    create: 'créer',
    kanban: 'kanban',
    general: 'général',
    banking: 'bancaire',
    booking: 'réservation',
    profile: 'profil',
    account: 'compte',
    product: 'produit',
    invoice: 'facture',
    details: 'détail',
    checkout: 'vérifier',
    calendar: 'calendrier',
    analytics: 'analytique',
    ecommerce: 'e-commerce',
    management: 'management',
    menu_level: 'niveau menu',
    menu_level_2a: 'niveau menu 2a',
    menu_level_2b: 'niveau menu 2b',
    menu_level_3a: 'niveau menu 3a',
    menu_level_3b: 'niveau menu 3b',
    menu_level_4a: 'niveau menu 4a',
    menu_level_4b: 'niveau menu 4b',
    item_disabled: 'élément désactivé',
    item_label: 'étiquette de l\'article',
    item_caption: 'légende de l\'article',
    item_external_link: 'lien externe de l\'article',
    description: 'la description',
    other_cases: 'autres cas',
    item_by_roles: 'élément par rôles',
    only_admin_can_see_this_item: 'seul l\'administrateur peut voir cet élément',
};

export default fr;
